"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TokenSearch = void 0;
var fuse_js_1 = __importDefault(require("fuse.js"));
var TokenSearch = (function () {
    function TokenSearch() {
    }
    TokenSearch.searchTokens = function (tokens, searchTerm) {
        if (!searchTerm) {
            return tokens;
        }
        var fuse = new fuse_js_1.default(tokens, {
            keys: ["apiName", "name"],
            threshold: 0.1,
            ignoreLocation: true,
            useExtendedSearch: true,
        });
        var searchTerms = splitByPrefix(searchTerm);
        return fuse.search(constructExtendedSearchTerm(searchTerms)).map(function (result) { return result.item; });
    };
    return TokenSearch;
}());
exports.TokenSearch = TokenSearch;
var PREFIX_SYMBOL = ".";
var splitByPrefix = function (searchTerm) {
    var dotIndex = searchTerm.indexOf(PREFIX_SYMBOL);
    if (dotIndex < 0 || dotIndex === searchTerm.length - 1) {
        return [searchTerm];
    }
    var prefix = searchTerm.substring(0, dotIndex + 1);
    var search = searchTerm.substring(dotIndex + 1);
    return [prefix, search];
};
var constructExtendedSearchTerm = function (searchTerms) {
    return "".concat(searchTerms.map(function (searchTerm) { return "\"".concat(searchTerm, "\""); }).join(" "));
};
